import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import fallback from '../../fallback';

export default (http: AxiosInstance) => ({

    /**
     * @description list of sliders
     *
     * @tags open
     * @name collectionSliderList
     * @request GET:/collection/sliders/list
     * @response `200` `SliderListData` success getting drop list
     * @response `default` `EmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any content answers
     */
    async collectionSliderList() {
        const res = await http.get<AppResponseType<AppWTFCollectionSlider[]>>(`/collection/slider/list`);
        return res.data;
    },

    async collectionGet(slug: string) {
        const res = await http.get<AppWTFCollectionResponse>(`/collection/${slug}`);
        return res.data;
    },

    async collectionList(query?: AppWTFCollectionListQuery) {
        const fallbackConfig = fallback<AppWTFCollectionListResponse>({
            text: 'Loading collections',
            description: 'An error occurred while loading collection',
            visible: 'error',
            exclude: [
                404,
                403
            ],
            fallback: {
                data: [],
                pagination: {
                    page: 0,
                    size: 0,
                    total: 0
                },
                status: {
                    code: 404,
                    message: 'Response fallbackApi',
                    msgId: '1'
                }
            }
        });

        const config: AxiosRequestConfig = {
            params: {
                ...query
                    ? { ...query }
                    : {}
            },
            ...fallbackConfig
        };

        const res = await http.get<AppWTFCollectionListResponse>(
            '/collections',
            config
        );
        return res.data;
    },

    /**
     * @description Returns a pack of collection based on provided IDs
     *
     * @tags open
     * @name CollectionPack
     * @request POST:/collection/pack
     * @response `200` `CollectionPackData` List of collection
     * @response `default` `EmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any data answers
     */
    async collectionPack(uuids: string[]) {
        const res = await http.post<AppResponseType<AppWTFCollection[]>>(`/collections/pack`, { ids: uuids });
        return res.data;
    }
} as const);
